import React, { FC }               from 'react';
import { capitalize }                             from '../../util';
import { ColoredClosableHeader, StyledContainer } from '../containers';
import { Size }                                   from '../../types/componentPropTypes';

export interface ContentContainerProps {
	title?: string
}

const defaultProps: ContentContainerProps = {
	title: 'Summary'
};

const ContentContainer: FC<ContentContainerProps> = ( props ) => {
	
	return (
		<>
			{ props.title && <ColoredClosableHeader headerProps={ { as: 'h3' } } title={ capitalize( props.title ) }/> }
			
			<StyledContainer padding={ [ Size.MD, Size.MD, Size.LG, Size.MD ] }>
				
				{ props.children }
			
			</StyledContainer>
		</>
	);
};

ContentContainer.defaultProps = defaultProps;

export { ContentContainer }
